import React, { useEffect, useState } from 'react';

import { Container, Footer, MainContent, MenuAppBarDiv } from './styles';
import MenuAppBar from '../menuAppBar';
import { useAuth } from '../../context/authContext';
import { useTheme } from '../../context/ThemeContext';
import { netzwerkBackground } from '../../assets/netzwerkBackground';
import darkBackgroundImage from '../../assets/Background-HomePage.png';
import EnumPermissions from '../../utils/Enums/EnumPermissons';

export interface Page {
  name: string;
  route: string;
  permission: string;
}
interface MainProps {
  children: any;
  noPadding?: boolean;
}

const allPages: Page[] = [
  { name: 'Home', route: '/', permission: EnumPermissions.CAN_ACCESS_HOME },
  {
    name: 'Companies',
    route: '/companies',
    permission: EnumPermissions.CAN_ACCESS_COMPANIES,
  },
  {
    name: 'Uploads',
    route: '/uploadedFiles',
    permission: EnumPermissions.CAN_ACCESS_USERGROUPS,
  },
  {
    name: 'User Groups',
    route: '/usergroups',
    permission: EnumPermissions.CAN_ACCESS_USERGROUPS,
  },
  {
    name: 'Users',
    route: '/users',
    permission: EnumPermissions.CAN_ACCESS_USERS,
  },
  {
    name: 'Logs',
    route: '/logs',
    permission: EnumPermissions.CAN_ACCESS_LOGS,
  },
  {
    name: 'Access Control',
    route: '/accesscontrol',
    permission: EnumPermissions.CAN_ACCESS_ROLES_AND_PERMISSIONS,
  },
  {
    name: 'Chatbot Context',
    route: '/dashboardContext',
    permission: EnumPermissions.CAN_UPLOAD_DASHBOARD_CONTEXT,
  },
];

const MainLayout: React.FC<MainProps> = ({ children, noPadding = false }) => {
  const { user } = useAuth();
  const { isDarkMode } = useTheme();
  const [userPages, setUserPages] = useState<Page[]>([]);

  useEffect(() => {
    const pagesByUserRole = user.permissions.flatMap((userPermission: any) => {
      return allPages.filter(
        (page: Page) =>
          page.permission.toLowerCase() === userPermission.name.toLowerCase(),
      );
    });

    setUserPages(pagesByUserRole);
  }, [user.permissions]);

  return (
    <>
      <MenuAppBarDiv id="menuAppBar">
        <MenuAppBar pages={userPages} />
      </MenuAppBarDiv>
      <Container id="container">
        <MainContent
          id="main-content"
          $noPadding={noPadding}
          style={{
            height: '100%',
            width: '100%',
            ...(isDarkMode
              ? {
                  backgroundImage: noPadding
                    ? undefined
                    : `url(${darkBackgroundImage})`,
                  backgroundColor: '#7e7e7e',
                  backgroundSize: '101% 101%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPositionX: '9%',
                  backgroundBlendMode: 'normal',
                }
              : {
                  backgroundImage: noPadding ? undefined : netzwerkBackground,
                  backgroundSize: 'auto 115%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right center',
                  backgroundBlendMode: 'normal',
                }),
          }}
        >
          {children}
        </MainContent>
      </Container>
      <Footer>
        {/* <p>Copyright @ 2025 emotion banking GmbH</p> */}
        <img
          style={{ marginLeft: '-15px' }}
          width="70px"
          height="41px"
          src="https://api.meine-sicht.com/files/69d36b0cae13b61e4012-logo-cyberTrust.svg"
          alt="Cyber Trust Austria Standard Label"
          sizes="(max-width: 800px) 100vw, 800px"
          title="Cyber Trust Austria Standard Label"
        ></img>
        <img
          width="70px"
          height="41px"
          src="https://www.emotion-banking.at/wp-content/uploads/2025/02/Siegel-Hosted-in-Europe-c02df432-2048x1331-1-1024x666.webp"
          alt="Siegel-Hosted-in-Europ"
          sizes="(max-width: 800px) 100vw, 800px"
        ></img>
      </Footer>
    </>
  );
};

export default MainLayout;
